import { Center, Loader, MantineProvider } from "@mantine/core";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";

// Self-hosted so the page still makes no third-party request, and subset by unicode-range so only Latin loads.
import "@fontsource-variable/roboto";
import "@mantine/core/styles.css";
import "@mantine/spotlight/styles.css";
import "./global.css";

import { Layout } from "./layout";
import { PageLoader } from "./page-loader";
import { cssVariablesResolver, theme } from "./theme";

// One page per document: the address was answered by a document of its own, so there is no route to read and no
// address this can be asked for that the host has not already answered with the 404 page.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <MantineProvider
    theme={theme}
    defaultColorScheme="dark"
    forceColorScheme="dark"
    cssVariablesResolver={cssVariablesResolver}
  >
    <Layout>
      <Suspense
        fallback={
          <Center h="100%">
            <Loader />
          </Center>
        }
      >
        <PageLoader />
      </Suspense>
    </Layout>
  </MantineProvider>,
);
